import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/asiaemergingmarket/frontend/frontastic/renderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/asiaemergingmarket/frontend/providers/index.tsx");
